export const LOCAL_KEY_LANG_SETTING = "LOCAL_KEY_LANG_SETTING";

// 订单确认页会话信息
export const SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE =
  "SESSION_KEY_IS_ROUTE_FROM_CONFIRM_ORDER_PAGE";

export const SESSION_KEY_CUSTOMER_REMARK = "SESSION_KEY_CUSTOMER_REMARK";

export const SESSION_KEY_SELECTED_PAYMENT_METHOD =
  "SESSION_KEY_SELECTED_PAYMENT_METHOD";

export const SESSION_KEY_IS_PRIVACY_POLICY_CHECKED =
  "SESSION_KEY_IS_PRIVACY_POLICY_CHECKED";

export const SESSION_KEY_IS_USER_TERMS_CHECKED =
  "SESSION_KEY_IS_USER_TERMS_CHECKED";
